import React, { useEffect, useState } from "react";
import Header from "../../component/frontend/Header";
import Footer from "./Footer";
import "../../css/style.css";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import BloodPressureChart from "./BloodPressureChart";
import HeartRateChart from "./HeartRateChart";
import TemperatureChart from "./TemperatureChart";
import WeightChart from "./WeightChart";
import SwiperComponent from "../SwiperComponent";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import axios from "axios";
import { Link, Route } from "react-router-dom";
import { USER_LOCAL_ID } from "../../constants";
import BookAppointmentPopup from "./BookAppointmentPopup";
import PopupIndex4 from "./PopupIndex4";
import { scAxiosAdmin } from "../..";

const PatientProtal = () => {
  const [data, setData] = useState([]);
  const [bookAppointmentPopupClicked, setBookAppointmentPopupClicked] =
    useState(false);
  console.log(data, "pakages_data");
  // const patientId = "1000555116";
  // const id = localStorage.getItem("USER_ID")

  const patientId = "1000555116";

  const requestBody = {
    patient: patientId,
  };

  // const requestBody = JSON.stringify(dataToSend);
  // console.log(requestBody,"pakages_data")

  // const patientId = "1000555116";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await scAxiosAdmin.post(
          "/job_applications",

          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        setData(response.data); // Assuming the response contains the data you need
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const bloodPressureData = {
    labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5"],
    datasets: [
      { name: "Systolic Pressure", data: [120, 130, 125, 140, 135] },
      { name: "Diastolic Pressure", data: [80, 85, 78, 90, 82] },
    ],
  };
  const heartRateData = {
    labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5"],
    datasets: [{ name: "Heart Rate", data: [75, 80, 85, 90, 95] }],
  };
  const temperatureData = {
    labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5"],
    datasets: [{ name: "Temperature", data: [25, 28, 24, 30, 22] }],
  };
  const weightData = {
    labels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5"],
    datasets: [{ name: "Weight", data: [70, 72, 69, 73, 68] }],
  };

  function extractBloodPressureValues(data) {
    const pressureValues = data.map((entry) => {
      const bloodPressure = entry.Blood_Pressure || ""; // Handle cases where Blood_Pressure is undefined or empty

      // Extract systolic and diastolic pressure values using regular expression
      const matches = bloodPressure.match(/(\d+)\/(\d+)/);

      // If there are matches, return an object with systolic and diastolic pressure values
      if (matches && matches.length === 3) {
        return {
          systolicPressure: parseInt(matches[1]),
          diastolicPressure: parseInt(matches[2]),
        };
      }

      // If no matches, return null or handle it based on your requirements
      return null;
    });

    // Filter out entries where blood pressure values couldn't be extracted
    const validPressureValues = pressureValues.filter(
      (entry) => entry !== null
    );

    // Separate systolic and diastolic pressure values into two arrays
    const systolicPressures = validPressureValues.map(
      (entry) => entry.systolicPressure
    );
    const diastolicPressures = validPressureValues.map(
      (entry) => entry.diastolicPressure
    );

    return { systolicPressures, diastolicPressures };
  }

  // Example usage with your array of objects
  const datas = [
    {
      Temperature: "",
      Hight: "0.00",
      Oxygen_saturation: "",
      Pulse_Rate: "86",
      Blood_Pressure: "",
      Heart_rate: "",
      Respiration: "",
      Weight: "0.00",
      Date: "2022-03-07",
      BMI: "0.00",
    },
    {
      Temperature: "",
      Hight: "0.00",
      Oxygen_saturation: "",
      Pulse_Rate: "86",
      Blood_Pressure: "110/70",
      Heart_rate: "",
      Respiration: "",
      Weight: "0.00",
      Date: "2022-03-07",
      BMI: "0.00",
    },
    {
      Temperature: "",
      Hight: "0.00",
      Oxygen_saturation: "98%",
      Pulse_Rate: "86",
      Blood_Pressure: "110/70",
      Heart_rate: "",
      Respiration: "",
      Weight: "0.00",
      Date: "2022-03-07",
      BMI: "0.00",
    },
    {
      Temperature: "",
      Hight: "0.00",
      Oxygen_saturation: "99%",
      Pulse_Rate: "66",
      Blood_Pressure: "100/60",
      Heart_rate: "",
      Respiration: "",
      Weight: "0.00",
      Date: "2022-03-31",
      BMI: "0.00",
    },
    {
      Temperature: "",
      Hight: "0.00",
      Oxygen_saturation: "98%",
      Pulse_Rate: "72",
      Blood_Pressure: "140/85",
      Heart_rate: "",
      Respiration: "",
      Weight: "0.00",
      Date: "2022-05-08",
      BMI: "0.00",
    },
    {
      Temperature: "",
      Hight: "0.00",
      Oxygen_saturation: "98%",
      Pulse_Rate: "71",
      Blood_Pressure: "120/80",
      Heart_rate: "",
      Respiration: "",
      Weight: "0.00",
      Date: "2022-09-13",
      BMI: "0.00",
    },
    {
      Temperature: "",
      Hight: "0.00",
      Oxygen_saturation: "96%",
      Pulse_Rate: "94",
      Blood_Pressure: "140/80",
      Heart_rate: "",
      Respiration: "",
      Weight: "0.00",
      Date: "2023-01-11",
      BMI: "0.00",
    },
    {
      Temperature: "",
      Hight: "161",
      Oxygen_saturation: "98%",
      Pulse_Rate: "60",
      Blood_Pressure: "90/60",
      Heart_rate: "",
      Respiration: "",
      Weight: "75",
      Date: "2023-05-24",
      BMI: "28.90",
    },
  ];

  const { systolicPressures, diastolicPressures } =
    extractBloodPressureValues(datas);

  return (
    <div>
      <SEO
        title="Patient Portal | Best Hospital in Bangladesh | United Hospital"
        description="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        pathSlug="/"
        keywords="Services"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>

      <Route component={Header} />
      <div
        id="giveMarginService"
        className="allservices"
        style={{ backgroundColor: "#fef3e9" }}
      >
        <div className="container pt-5 ">
          {/* <h3 className="text-center mb-3">
                        Patient Protal  <hr />
                    </h3> */}
          {/* <Swiper
            spaceBetween={30}
            slidesPerView={6}
            breakpoints={{
              // When window width is <= 767px (for mobile)
              300: {
                slidesPerView: 1.7, // Change slidesPerView for mobile
              },
              800: {
                slidesPerView: 3.5, // Change slidesPerView for mobile
              },
              1000: {
                slidesPerView: 6, // Change slidesPerView for mobile
              },
            }}
            style={{ width: "80%" }}
          >
            <SwiperSlide>
              <div
                className="col-md-3"
                style={{
                  backgroundColor: "#e5e5e5",
                  width: "204px",
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "284px",
                  flexDirection: "column",
                  rowGap: "15px",
                }}
              >
                <svg
                  style={{ color: "#bdbbbb" }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-plus-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>
                <p style={{ fontWeight: "bold", color: "#bdbbbb" }}>
                  Add Family
                </p>
              </div>
            </SwiperSlide>
          </Swiper> */}
          {/*  */}
          <div
            className="row pb-3 g-0"
            style={{
              display: "flex",
              columnGap: "15px",
              rowGap: "15px",
              //  width: "90vw",
              // maxWidth: "1140px",
              // margin: "0 auto",
            }}
          >
            <div
              className="col-md-7 p-3 d-none"
              style={{
                backgroundColor: "#fff",
                width: "620px",
                borderRadius: "5px",
              }}
            >
              <div
                className="no1 mt-2 p-2"
                style={{
                  boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
                  borderRadius: "5px",
                }}
              >
                <div className="box d-flex justify-content-between align-items-center p-2">
                  <div
                    className="box1 d-flex lign-items-center "
                    style={{ columnGap: "10px", rowGap: "10px" }}
                  >
                    <img src="/assets/images/blood-pressure 1 (2).png" alt="" />
                    <h4
                      className="text-center pt-2"
                      style={{ fontWeight: "bold" }}
                    >
                      Blood Pressure
                    </h4>
                  </div>

                  <img src="/assets/images/menu-dots 1.png" alt="" />
                </div>
                <h4
                  style={{
                    fontWeight: "bold",
                    color: "#187979",
                    paddingLeft: "3.5rem",
                  }}
                >
                  120/80
                </h4>
                <BloodPressureChart data={bloodPressureData} />
              </div>
              <div
                className="no1 mt-2 p-2"
                style={{
                  boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
                  borderRadius: "5px",
                }}
              >
                <div className="box d-flex justify-content-between align-items-center p-2">
                  <div
                    className="box1 d-flex lign-items-center "
                    style={{ columnGap: "10px", rowGap: "10px" }}
                  >
                    <img src="/assets/images/blood-pressure 2.png" alt="" />
                    <h4
                      className="text-center pt-2"
                      style={{ fontWeight: "bold" }}
                    >
                      Heart Rate
                    </h4>
                  </div>

                  <img src="/assets/images/menu-dots 1.png" alt="" />
                </div>
                <h4
                  style={{
                    fontWeight: "bold",
                    color: "#187979",
                    paddingLeft: "3.5rem",
                  }}
                >
                  70
                </h4>
                <HeartRateChart data={heartRateData} />
              </div>
              <div
                className="no1 mt-2 p-2"
                style={{
                  boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
                  borderRadius: "5px",
                }}
              >
                <div className="box d-flex justify-content-between align-items-center p-2">
                  <div
                    className="box1 d-flex lign-items-center "
                    style={{ columnGap: "10px", rowGap: "10px" }}
                  >
                    <img src="/assets/images/temperature 1.png" alt="" />
                    <h4
                      className="text-center pt-2"
                      style={{ fontWeight: "bold" }}
                    >
                      Temperature
                    </h4>
                  </div>

                  <img src="/assets/images/menu-dots 1.png" alt="" />
                </div>
                <h4
                  style={{
                    fontWeight: "bold",
                    color: "#187979",
                    paddingLeft: "3.5rem",
                  }}
                >
                  99.1 c{" "}
                </h4>
                <TemperatureChart data={temperatureData} />
              </div>

              <div
                className="no1 mt-2 mb-2 p-2"
                style={{
                  boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
                  borderRadius: "5px",
                }}
              >
                <div className="box d-flex justify-content-between align-items-center p-2">
                  <div
                    className="box1 d-flex lign-items-center "
                    style={{ columnGap: "10px", rowGap: "10px" }}
                  >
                    <img src="/assets/images/blood-pressure 1 (1).png" alt="" />
                    <h4
                      className="text-center pt-2"
                      style={{ fontWeight: "bold" }}
                    >
                      Weight
                    </h4>
                  </div>

                  <img src="/assets/images/menu-dots 1.png" alt="" />
                </div>
                <h4
                  style={{
                    fontWeight: "bold",
                    color: "#187979",
                    paddingLeft: "3.5rem",
                  }}
                >
                  80 kg
                </h4>

                <WeightChart data={weightData} />
              </div>
            </div>
            <div
              className="col-md-5 p-3"
              style={{
                backgroundColor: "#fff",
                borderRadius: "5px",
                height: "fit-content",
              }}
            >
              {localStorage.getItem(USER_LOCAL_ID) ? (
                <a
                  className="text-decoration-none"
                  // href="#offcanvasExample"
                  data-bs-toggle="offcanvas"
                  role="button"
                  data-bs-target="#BookAppointMent"
                  aria-controls="BookAppointMent"
                  onClick={() => setBookAppointmentPopupClicked(true)}
                >
                  <div
                    className="no1 mt-2 mb-2 p-3 d-flex justify-content-center flex-column align-items-center"
                    style={{
                      boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
                      borderRadius: "5px",
                      columnGap: "10px",
                      rowGap: "10px",
                    }}
                  >
                    <svg
                      style={{ color: "#29bc97" }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="35"
                      height="35"
                      fill="currentColor"
                      className="bi bi-plus-circle"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    <h4 style={{ fontSize: "14px" }}>Book Appointments</h4>
                  </div>
                </a>
              ) : (
                <a
                  className="text-decoration-none"
                  href="#offcanvasExample"
                  data-bs-toggle="offcanvas"
                  role="button"
                  aria-controls="offcanvasExample"
                >
                  <div
                    className="no1 mt-2 mb-2 p-3 d-flex justify-content-center flex-column align-items-center"
                    style={{
                      boxShadow: "0px -3px 30px 7px rgba(0,0,0,0.1)",
                      borderRadius: "5px",
                      columnGap: "10px",
                      rowGap: "10px",
                    }}
                  >
                    <svg
                      style={{ color: "#29bc97" }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="35"
                      height="35"
                      fill="currentColor"
                      className="bi bi-plus-circle"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    <h4 style={{ fontSize: "14px" }}>Book Appointments</h4>
                  </div>
                </a>
              )}

              <SwiperComponent />
            </div>
          </div>
        </div>
      </div>
      <BookAppointmentPopup
        bookAppointmentPopupClicked={bookAppointmentPopupClicked}
        setBookAppointmentPopupClicked={setBookAppointmentPopupClicked}
      ></BookAppointmentPopup>
      <PopupIndex4></PopupIndex4>
      <Footer />
    </div>
  );
};

export default PatientProtal;



// WEBPACK FOOTER //
// ./src/component/frontend/PatientProtal.js